{
  "decrease": "Scădere {fieldLabel}",
  "increase": "Creștere {fieldLabel}",
  "numberField": "Câmp numeric"
}
